import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { TimeMetricCard } from './TimeMetricCard';
import TimerIcon from '@mui/icons-material/Timer';
import { TimeRatioBar } from './TimeRatioBar';
import { formatTime } from '../../utils';
import React from 'react';

interface CycleOverviewProps {
  data: {
    avgWaitTime: number;
    avgAttentionTime: number;
    avgTotalTime: number;
  };
}

export const CycleOverview: React.FC<CycleOverviewProps> = ({ data }) => {
  const totalTime = formatTime(data.avgTotalTime);
  const waitTime = formatTime(data.avgWaitTime);
  const attentionTime = formatTime(data.avgAttentionTime);

  return (
    <div className='bg-white p-8 rounded-2xl shadow-lg border border-slate-100 flex flex-col justify-between h-full hover:shadow-2xl transition-all duration-300 group'>
      <div className='mb-6'>
        <h3 className='text-slate-400 text-[10px] font-black uppercase tracking-[0.2em] flex items-center gap-2 mb-6 group-hover:text-orange-500 transition-colors'>
          <AccessTimeIcon className='!w-5 !h-5 text-orange-500' />
          Promedio desde que se emitio el ticket hasta que se retira
        </h3>
        <div className='flex flex-col animate-in slide-in-from-left duration-700'>
          <span className='text-7xl font-[1000] text-slate-900 leading-none tracking-tighter'>
            {totalTime.value}
          </span>
          <span className='text-base font-black text-slate-400 uppercase tracking-tighter mt-1'>
            {totalTime.unit === 's'
              ? 'segundos'
              : totalTime.unit === 'min'
                ? 'min'
                : ''}{' '}
          </span>
        </div>
      </div>

      <div className='grid grid-cols-2 gap-6'>
        <TimeMetricCard
          icon={HourglassEmptyIcon}
          label='Espera'
          value={waitTime.value}
          unit={waitTime.unit}
          colorScheme='amber'
        />
        <TimeMetricCard
          icon={TimerIcon}
          label='Atención'
          value={attentionTime.value}
          unit={attentionTime.unit}
          colorScheme='emerald'
        />
      </div>

      <TimeRatioBar
        waitTime={data.avgWaitTime}
        attentionTime={data.avgAttentionTime}
        totalTime={data.avgTotalTime}
      />
    </div>
  );
};
